// extracted by mini-css-extract-plugin
module.exports = {"Button":"_3OY37ptzeNAwwBT1cLg7mB"};